const getRouteKey = route => {
  if (!route) return ""
  return (route.meta && route.meta.permission) || route.name || ""
}

export const buildMenuTree = routes => {
  if (!Array.isArray(routes)) return []

  return routes
    .filter(route => route && !route.hidden && route.meta && route.meta.title)
    .map(route => {
      const children = buildMenuTree(route.children || [])
      return {
        key: getRouteKey(route),
        label: route.meta.title,
        path: route.path,
        children
      }
    })
    .filter(menu => menu.key)
}

export const flattenMenuKeys = menuTree => {
  const keys = []

  const walk = menus => {
    menus.forEach(menu => {
      if (menu.key) keys.push(menu.key)
      if (menu.children && menu.children.length) walk(menu.children)
    })
  }

  walk(menuTree || [])
  return keys
}

export const flattenLeafMenuKeys = menuTree => {
  return (menuTree || []).reduce((keys, menu) => {
    if (menu.children && menu.children.length) {
      return keys.concat(flattenLeafMenuKeys(menu.children))
    }
    if (menu.key) keys.push(menu.key)
    return keys
  }, [])
}

export const filterRoutesByMenuKeys = (routes, menuKeys) => {
  const allowedKeys = new Set(menuKeys || [])

  const filterRoutes = (routeList, parentAllowed = false) => {
    return (routeList || []).reduce((result, route) => {
      if (!route) return result

      const routeKey = getRouteKey(route)
      const ownAllowed = routeKey ? allowedKeys.has(routeKey) : false
      const hiddenAllowed = Boolean(route.hidden && parentAllowed)
      const children = filterRoutes(
        route.children || [],
        ownAllowed || hiddenAllowed
      )

      if (ownAllowed || hiddenAllowed || children.length) {
        result.push({
          ...route,
          ...(route.children ? { children } : {})
        })
      }

      return result
    }, [])
  }

  return filterRoutes(routes)
}
